<div class="message-item-wrapper">
  <!--  <div *ngIf="message.isLocalOnly" class="text-yellow-500 waiting-message">Waiting for network...</div>-->
  <div [ngClass]="{ 'is-local-only': message?.isLocalOnly }" class="inner-wrapper">
    <div class="profile-pic-container">
      <div class="rounded-profile-pic">
        @switch (profilePicUrl) {
          @case (DEFAULT_IMAGE) {
            <span class="icon-logo-box-hex text-blue-700"></span>
          }
          @case (undefined) {
            <span class="icon-refresh animate-spin pic-loading"></span>
          }
          @default {
            <img [src]="profilePicUrl" />
          }
        }
      </div>
    </div>
    <div class="flex-1 message-item-content pr-1">
      <div class="message-item-header flex justify-between items-baseline">
        <div class="flex gap-1.5 items-baseline">
          <span class="text-navy-900 font-bold text-size_xl">{{ message?.user?.name }}</span>
          <span class="text-navy-900 font-normal text-size_l">{{ message?.user?.company_name }}</span>
          @if (message?.user?.was_deleted) {
            <span class="text-red-500 font-bold text-size_l">User no longer exists.</span>
          }
        </div>
        <div class="flex text-size_l text-navy-600 gap-4">
          <span> {{ message?.updated_at | datepipe: 'LT' | uppercase }} </span>
          <span> {{ message?.updated_at | datepipe: 'MMM DD' | uppercase }} </span>
        </div>
      </div>
      @if (message?.body !== '<p><br></p>') {
        <div class="message" [innerHTML]="message?.body"></div>
      }
      @for (attachment of message?.attachments; track attachment) {
        <div (click)="downloadAttachment(attachment)" class="text-blue-700 pointer-cursor">
          {{ attachment.name }}
        </div>
      }
      @if (!hideReplies) {
        <div class="message-item-footer text-size_m flex gap-4 items-baseline w-fit">
          <div
            (click)="message?.thread?.length ? openThread(message) : $event.stopPropagation()"
            [ngClass]="{ 'pointer-cursor': message?.thread?.length, 'cursor-default': !message?.thread?.length }"
            class="text-navy-700"
          >
            {{ message?.thread ? message?.thread?.length : 0 }} Replies
          </div>
          <div (click)="openThread(message)" class="text-blue-700 cursor-pointer font-semibold hover:text-navy-700 p-1">
            Reply
          </div>
          @if (message?.is_read === false) {
            <div class="text-yellow-500 font-semibold p-1">Unread messages</div>
          }
        </div>
      }
    </div>
  </div>
</div>
